import React from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'hooks/use-redux'
import { isClientLibrariesTrial } from '@disco/state-management/selectors/user'
import BrowseLibraries from './BrowseLibraries'

const BrowseLibrariesSearchContainer = (): React.ReactNode => {
  const location = useLocation()
  const clientLibrariesTrial: boolean = useSelector(isClientLibrariesTrial)
  return (
    <BrowseLibraries
      showInBrowseLibrariesPage={false}
      clientLibrariesTrial={clientLibrariesTrial}
      location={location}
    />
  )
}

export default BrowseLibrariesSearchContainer
